import {connect, IConnectProps} from 'globx-react';
import * as React               from 'react';
import {Subject}                from 'rxjs';

import StoreName              from '../../../../State/Shared/Constants/StoreName';
import FrameModel             from '../../../../State/Stores/Frame/Frame';
import {PLAYER_FRAME}         from '../../../Shared/Constants/TestIds';
import UiEventType            from '../../../Shared/Constants/UiEventType';
import IUiEventsStreamPayload from '../../../Shared/Interfaces/IUiEventsStreamPayload';
import composeTokenList       from '../../Util/composeTokenList';
import renderTestId           from '../../Util/renderTestId';
import Bar                    from '../Bar';
import PlaybackButtons        from '../PlaybackButtons';
import Poster                 from '../Poster';
import SettingsContainer      from '../Settings/Container';
import Spinner                from '../Spinner';
import TextTrack              from '../TextTrack';
import Watermark              from '../Watermark';

import * as styles from './frame.css';

interface IFrameProps extends IConnectProps<FrameModel> {
    uiEvents$: Subject<IUiEventsStreamPayload>;
}

@connect(StoreName.FRAME)
class Frame extends React.Component<IFrameProps> {
    private rootRef: HTMLDivElement;

    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    public shouldComponentUpdate(nextProps: IFrameProps): boolean {
        return this.props.value.controlsStatus !== nextProps.value.controlsStatus ||
            this.props.value.isSettingsOpen !== nextProps.value.isSettingsOpen;
    }

    public render(): JSX.Element {
        const {value, uiEvents$} = this.props;

        const className = composeTokenList([
            styles.frame,
            [value.areControlsIdle, styles.frameIdle]
        ]);

        return (
            <div
                className={className}
                onClick={this.handleClick}
                data-test-id={renderTestId(PLAYER_FRAME)}
                ref={this.setRootRef}
            >
                <Poster/>
                <TextTrack/>
                <Spinner/>
                <PlaybackButtons
                    uiEvents$={uiEvents$}
                    areControlsIdle={value.areControlsIdle}
                    isSettingsOpen={value.isSettingsOpen} />
                <Bar
                    uiEvents$={uiEvents$}
                    areControlsIdle={value.areControlsIdle}
                    isSettingsOpen={value.isSettingsOpen} />
                <Watermark/>
                <SettingsContainer
                    uiEvents$={uiEvents$}
                    isSettingsOpen={value.isSettingsOpen} />
            </div>
        );
    }

    private setRootRef = element => this.rootRef = element;

    private handleClick(e: React.MouseEvent<HTMLDivElement>): void {
        if (e.target !== this.rootRef) return;

        this.props.uiEvents$.next({
            type: UiEventType.FRAME_TAP
        });
    }
}

export default Frame;